import { AssetType } from '../enums/AssetType'
import { Asset, AssetQuery } from '../types'
import { AssetStatus } from '../types/Asset'

const assetQueryKeys: Array<keyof AssetQuery> = [
  'companyId',
  'projectId',
  'levelId',
  'liftId',
  'type',
  'status',
  'virtual',
  'detached',
  'withDetached'
]

export function hasActiveAssetFilters(query: AssetQuery, initialQuery: AssetQuery = {}): boolean {
  return assetQueryKeys.some((key) => {
    const queryValue = key === 'withDetached' ? query[key] === true : query[key]
    const initialValue = key === 'withDetached' ? initialQuery[key] === true : initialQuery[key]

    return queryValue !== initialValue
  })
}

export function getAssetResetQuery(initialQuery: AssetQuery = {}): AssetQuery {
  return {
    ...(initialQuery.companyId !== undefined && { companyId: initialQuery.companyId }),
    ...(initialQuery.projectId !== undefined && { projectId: initialQuery.projectId }),
    ...(initialQuery.levelId !== undefined && { levelId: initialQuery.levelId }),
    ...(initialQuery.liftId !== undefined && { liftId: initialQuery.liftId }),
    withDetached: false
  }
}

export const isAssetActive = (asset: Asset): boolean => {
  return asset.status === AssetStatus.ACTIVE
}

export const isAssetInactive = (asset: Asset): boolean => {
  return asset.status === AssetStatus.INACTIVE
}

export const isAssetSoftDeleted = (asset: Asset): boolean => {
  return asset.deletedAt !== null
}

export const getDetachmentDateByAsset = (asset: Asset): Date | null => {
  let assetHistory: Record<string, Asset> = {}

  if (asset.type === AssetType.DEVICE && asset?.device && asset?.device?.assetHistory) {
    assetHistory = asset.device.assetHistory
  } else if (
    asset.type === AssetType.RUUVI_TAG &&
    asset?.ruuviTag &&
    asset?.ruuviTag?.assetHistory
  ) {
    assetHistory = asset.ruuviTag.assetHistory
  }

  // Sort the timestamps in descending order.
  const timestamps = Object.keys(assetHistory).sort(
    (a, b) => new Date(b).getTime() - new Date(a).getTime()
  )

  const timestamp = timestamps.find((timestamp) => assetHistory[timestamp].id === asset.id)

  return timestamp ? new Date(timestamp) : null
}
